import PropTypes from 'prop-types';
import React from 'react';
import {
  FOOTER_DEALS_LINKS,
  FOOTER_COMPANY_LINKS,
  FOOTER_CUSTOMER_SERVICE_LINKS,
  LINKS_GLOBAL_WOWCHER,
} from '../../config/links/links';
import {
  DOWNLOAD_THE_APP,
  FOOTER_COMPANY_TITLE,
  FOOTER_DEALS_TITLE,
  FOOTER_CUTOMER_SERVICE_TITLE,
} from '../../config/text/text';
import CareersImageLink from '../footer/CareersImageLink';
import DownloadAppLinks from '../footer/DownloadAppLinks';
import FooterColHeading from '../footer/FooterColHeading';
import FooterContainer from '../footer/FooterContainer';
import FooterLegalText from '../footer/FooterLegalText';
import FooterLinkList from '../footer/FooterLinkList';
import SocialMediaShareButtons from '../footer/SocialMediaShareButtons';
import FooterCol from '../footer/footerCol';

const Footer = ({ site = 'wowcher' }) => {
  const deals = [...FOOTER_DEALS_LINKS[site]];
  if (site === 'wowcher') {
    deals.unshift({
      href: `${
        LINKS_GLOBAL_WOWCHER[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'][
          process.env.NEXT_PUBLIC_SITE || 'wowcher'
        ]
      }/deals/london/restaurants-food`,
      text: 'Restaurants',
    });
    deals.unshift({
      href: `${
        LINKS_GLOBAL_WOWCHER[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'][
          process.env.NEXT_PUBLIC_SITE || 'wowcher'
        ]
      }/deals/london`,
      text: 'Local',
    });
  }

  return (
    <>
      <div className="footer-gap">
        <FooterContainer>
          <div className="footer__row footer__row--flex footer__row--links">
            <FooterCol>
              <FooterLinkList linksList={deals} title={FOOTER_DEALS_TITLE} />
            </FooterCol>
            <FooterCol>
              <FooterLinkList
                linksList={FOOTER_COMPANY_LINKS[site]}
                title={FOOTER_COMPANY_TITLE}
              />
            </FooterCol>
            <FooterCol>
              <FooterLinkList
                linksList={FOOTER_CUSTOMER_SERVICE_LINKS[site]}
                title={FOOTER_CUTOMER_SERVICE_TITLE}
              />
            </FooterCol>
            <FooterCol className="footer__col--hidden-mobile">
              <FooterColHeading>{DOWNLOAD_THE_APP}</FooterColHeading>
              <DownloadAppLinks site={site} />
            </FooterCol>
            {
              <FooterCol
                className="footer__col--hidden-mobile"
                noRender={site !== 'wowcher'}
              >
                <CareersImageLink />
              </FooterCol>
            }
          </div>
          <div className="footer__row">
            <FooterLegalText isSecurePage={false} site={site} />
          </div>
          <div className="footer__row footer__row--flex footer__row--social">
            <SocialMediaShareButtons site={site} />
          </div>
        </FooterContainer>
      </div>
      <style jsx>{`
        .footer-gap {
          padding-top: 20px;
        }
        .footer__row {
          margin-bottom: 12px;
        }
        .footer__row:last-child {
          margin-bottom: 0;
        }
        .footer__row--flex {
          display: flex;
        }
        .footer__row--social {
          justify-content: flex-end;
        }
        @media (max-width: 767.98px) {
          .footer__row {
            margin-bottom: 0;
          }
          .footer__row--flex {
            flex-direction: column;
          }
          .footer__row--social {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

Footer.propTypes = {
  site: PropTypes.string,
};

export default Footer;
